import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { Layout } from '../../layouts'
import { ModelRecommendations } from '../ModelRecommendations/ModelRecommendations'
import { nonPersonalisedArticles } from './nonPersonalisedArticles'

type NonPersonalisedRecommededForYouProps = {
  whichId: string
  layout: Layout
}

export const NonPersonalisedRecommededForYou = ({
  whichId,
  layout,
}: NonPersonalisedRecommededForYouProps) => {
  const enableConsentBanner = useFeatureIsOn('enable-just-in-time-consent-banner')

  if (!enableConsentBanner) {
    return null
  }

  const model = {
    content: nonPersonalisedArticles,
    model: 'non-personalised',
  }

  return (
    <ModelRecommendations
      model={model}
      whichId={whichId}
      layout={layout}
      sectionTitle="You might like"
      enableConsentBanner={true}
    />
  )
}
